import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { fetchContent } from "@/lib/api";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustStrip from "@/components/landing/TrustStrip";
import BrandsMarquee from "@/components/landing/BrandsMarquee";
import Categories from "@/components/landing/Categories";
import SocialFeed from "@/components/landing/SocialFeed";
import Financing from "@/components/landing/Financing";
import Reviews from "@/components/landing/Reviews";
import Locations from "@/components/landing/Locations";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyBar from "@/components/landing/StickyBar";

export default function Landing() {
  const [content, setContent] = useState(null);
  const lenisRef = useRef(null);

  useEffect(() => {
    fetchContent()
      .then(setContent)
      .catch(() => setContent({ settings: {} }));
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (hash.length < 2) return;
      const el = document.querySelector(hash);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  const settings = content?.settings || {};
  const categories = content?.categories || [];
  const locations = content?.locations || [];
  const reviews = content?.reviews || [];
  const posts = content?.social_posts || [];

  return (
    <div className="pb-[60px] md:pb-0" data-testid="landing-page">
      <Navbar settings={settings} />
      <main>
        <Hero settings={settings} />
        <TrustStrip />
        <BrandsMarquee />
        <Categories settings={settings} categories={categories} />
        <SocialFeed settings={settings} posts={posts} />
        <Financing settings={settings} />
        <Reviews reviews={reviews} locations={locations} />
        <Locations locations={locations} />
        <FinalCTA settings={settings} />
      </main>
      <Footer settings={settings} locations={locations} />
      <StickyBar settings={settings} />
    </div>
  );
}
